/*
 * @Author: your name
 * @Date: 2020-04-03 11:23:51
 * @LastEditTime: 2020-11-05 09:22:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/sensors.js
 */
/**
 * 神策埋点上报
 */
// 按钮类型
const buttonType = (attr, eventName = 'uniform_invoice') => {
  window.sensors && window.sensors.track(eventName, {
    "button_type": attr
  }, () => {
    console.log('callback')
  })
}
// 页面名称
const pageName = (attr, eventName = 'uniform_invoice') => {
  window.sensors && window.sensors.track(eventName, {
    "page_name": attr
  }, () => {
    console.log('callback')
  })
}
// 页面曝光
const pageView = (attr, eventName = 'uniform_invoice') => {
  window.sensors && window.sensors.track(eventName, {
    "page_view": attr
  }, () => {
    console.log('callback')
  })
}
// 按钮类型
const invoiceType = (attr, eventName = 'uniform_invoice') => {
  window.sensors && window.sensors.track(eventName, {
    "invoice_type": attr
  }, () => {
    console.log('callback')
  })
}
// 业务类型
const serviceType = (attr, eventName = 'uniform_invoice') => {
  window.sensors && window.sensors.track(eventName, {
    "service_type": attr
  }, () => {
    console.log('callback')
  })
}
const popupView = (attr, eventName = 'uniform_invoice') => {
  window.sensors && window.sensors.track(eventName, {
    "popup_view": attr
  }, () => {
    console.log('callback')
  })
}

/**
 * 新埋点上报 通用
 * @param {*} eventName 上报事件名
 * @param {*} obj 上报对象
 */
const commonReport = (eventName, obj) => {
  window.sensors && window.sensors.track(eventName, obj, () => {
    console.log('callback')
  })
}



// 城市是否为空
const cityIsEmpty = (attr, eventName = 'invoice_screening') => {
  window.sensors && window.sensors.track(eventName, {
    "city_is_empty": attr
  }, () => {
    console.log('callback')
  })
}
// 时间是否为空
const timeIsEmpty = (attr, eventName = 'invoice_screening') => {
  window.sensors && window.sensors.track(eventName, {
    "time_is_empty": attr
  }, () => {
    console.log('callback')
  })
}



// 发票开票
const UNIFORM_INVOICE = 'uniform_invoice'
// 专票资质认证
const INVOICE_ZPZZRZ = 'invoice_ZPZZRZ'
// 发票筛选条件
const INVOICE_SCREENING = 'invoice_screening'
// 开票历史
const INVOICE_HISTORY = 'invoice_history'
// 同期发票
const APPLY_INVOICE = 'apply_invoice'


export default {
  UNIFORM_INVOICE,
  INVOICE_ZPZZRZ,
  INVOICE_SCREENING,
  INVOICE_HISTORY,
  APPLY_INVOICE,
  buttonType,
  invoiceType,
  pageView,
  pageName,
  serviceType,
  cityIsEmpty,
  timeIsEmpty,
  popupView,
  commonReport
}


// WEBPACK FOOTER //
// ./src/sensors.js